import { useState, useEffect } from 'react';

import { breakpoints } from '../styles/media';

const media = window.matchMedia(`(max-width: ${breakpoints.desktop}px)`);

const useDeviceType = () => {
  const [mobile, setMobile] = useState(media.matches);

  const mediaChange = () => {
    setMobile(media.matches);
  };

  useEffect(() => {
    media.onchange = mediaChange;
    return () => {
      media.onchange = null;
    };
  }, []);

  return { mobile };
};

export default useDeviceType;
